<template>
    <!-- Table [start] -->
    <div class="card">
        <div class="card-header">
            <div class="row align-items-center">
                <div class="col-sm-6 col-lg-8">
                    <h4 class="header-title">{{ $t('installationScenarios.listTitle') }}</h4>
                </div>
                <div class="col-sm-6 col-lg-4 mt-2 mt-sm-0">
                    <label class="d-flex justify-content-end align-items-center">
                        <input type="text" id="searchComponent" class="form-control form-control-sm" :placeholder="$t('common.search')" aria-controls="components-table"/>
                    </label>
                </div>
            </div>
        </div>
        <div class="card-body pt-0">
            <div class="component-treeview-legend tree-scenarios-legend">
                <div class="tree-cell component-name">{{ $t('installationScenarios.legend.scenario') }}</div>
                <div class="tree-cell component-state">{{ $t('installationScenarios.legend.state') }}</div>
                <div class="tree-cell component-action">{{ $t('installationScenarios.legend.actions') }}</div>
            </div>
            <div id="jstree-scenarios" ref="tree" class="component-treeview tree-scenarios">
                <ul>
                    <li v-for="hub in hubs" :key="hub.id" data-jstree='{ "icon" : "mdi mdi-server-network text-primary", "opened" : true }'>
                        <div class="tree-row">
                            <div class="tree-cell component-name fw-bold text-primary">{{ hub.label }}</div>
                            <div class="tree-cell component-action">
                                <TreeButton :label="$t('installationScenarios.addScenario')" type="btn btn-sm btn-info"
                                    icon="mdi-movie-open-plus" color="d-none d-md-inline ms-2"
                                    :path="{ path: '/component-edit-scenario', params: {facilityId: facilityId, hubId: hub.id, id: 0}}" />
                            </div>
                        </div>
                        <ul>
                            <li v-for="scenario in hub.scenarios" :key="scenario.id" :id="`${hub.id}_${scenario.id}`" data-jstree='{ "icon": "mdi mdi-movie-open text-dark" }'>
                                <div class="tree-row">
                                    <div class="tree-cell component-name fw-bold text-dark">
                                        <TreeButton :path="scenario.path(facilityId, hub.id)" :label="scenario.label" type="link" />
                                    </div>
                                    <div class="tree-cell component-state">
                                        <strong v-if="scenario.is_active" class="text-success">{{ $t('common.active') }}</strong>
                                        <strong v-else class="text-danger">{{ $t('common.inactive') }}</strong>
                                    </div>
                                    <div class="tree-cell component-action">
                                        <TreeButton :path="{ path: '/component-edit-scenario', params: { facilityId: facilityId, hubId: hub.id, id: scenario.id } }" />
                                        <TreeButton type="action-button" :path="{ action:'delete', id:`${hub.id}_${scenario.id}`}" class="btn btn-sm btn-danger ms-2 tree-action-button" icon="mdi-delete" :label="$t('common.delete')" />
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <!-- Table [end] -->
    <ConfirmationModal ref="confirmDeleteModal" :title="$t('common.confirmDelete')" :question="$t('installationScenarios.confirmDeleteQuestion')" type="danger" :button1="$t('common.cancel')" :button2="$t('common.delete')" :action="deleteScenario" />
</template>

<script>
import { ref, onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useUserStore } from '@/stores/userStore';
import { useI18n } from 'vue-i18n';
import ConfirmationModal from '@/modals/confirmationModal.vue';
import TreeButton from '@/components/treeButton';
import $ from 'jquery';
import { showToast } from '@/services/toast';

export default {
    name: 'ComponentEdiScenario',
    components: {
        TreeButton,
        ConfirmationModal,
    },
    setup() {
        const router = useRouter();
        const route = useRoute();
        const { t } = useI18n();
        const facilityId = parseInt(route.query.id);
        const userStore = useUserStore();
        const hubs = userStore.getFacilityHubs(facilityId, "BoxInteg");
        const tree = ref(null);
        const selectedTreenode = ref(null);
        const confirmDeleteModal = ref(null);

        const toggleScenario = () => {
            let [hubId, scenarioId] = selectedTreenode.value.id.split("_");
            const hub = hubs.find(hub => hub.id == hubId);
            if (hub) {
                const scenario = hub.scenarios.find(scenario => scenario.id == scenarioId);
                if (scenario) {
                    scenario.is_active = !scenario.is_active;
                    const button = $('#' + selectedTreenode.value.id).find('button')[0];
                    const icon = $(button).find('i');
                    const span = $(button).find('span');
                    const strong = $('#' + selectedTreenode.value.id).find('strong')[0];
                    if (scenario.is_active) {
                        $(span).text(t('componentEditScenario.suspend'));
                        $(button).removeClass('btn-outline-success').addClass('btn-outline-danger');
                        $(button).attr('data-bs-target', '#confirmPausedModal');
                        $(icon).removeClass('mdi-motion-play-outline').addClass('mdi-motion-pause-outline');
                        $(strong).text(t('common.active'));
                        $(strong).removeClass('text-danger').addClass('text-success');
                    } else {
                        $(span).text(t('componentEditScenario.resume'));
                        $(button).removeClass('btn-outline-danger').addClass('btn-outline-success');
                        $(button).attr('data-bs-target', '#confirmPlayModal');
                        $(icon).removeClass('mdi-motion-pause-outline').addClass('mdi-motion-play-outline');
                        $(strong).text(t('common.inactive'));
                        $(strong).removeClass('text-success').addClass('text-danger');
                    }
                }
            }
        }

        function confirmDeleteScenario(id) {
            confirmDeleteModal.value.show(id);
        }

        async function deleteScenario() {
            let [hubId, scenarioId] = selectedTreenode.value.id.split("_");
            const hub = hubs.find(hub => hub.id == hubId);
            if (hub) {
                const success = await userStore.deleteScenario(facilityId, hub, scenarioId);
                if(success) {
                    $(tree.value).jstree('delete_node', selectedTreenode.value.id);
                    showToast('success', t('common.deleteSuccess'));
                } else {
                    showToast('error', t('common.deleteFailure'));
                }
            }
        }

        onMounted(() => {

            $(tree.value).jstree({
                plugins: ["search"],
                core: {
                    themes: {
                        responsive: false
                    },
                    check_callback: function () {
                        return true;
                    }
                },
                search: {
                show_only_matches: true,
                show_only_matches_children: true
                }
            });

            $(tree.value).on('click', '.tree-button', (event) => {
                const jsonURI = $(event.currentTarget).attr('data-url');
                const uri = JSON.parse(jsonURI);
                router.push({ path: uri.path, query: uri.params });
            });

            $(tree.value).on('click', '.tree-action-button', (event) => {
                const jsonURI = $(event.currentTarget).attr('data-url');
                const params = JSON.parse(jsonURI);
                switch(params.action) {
                    case 'delete':
                        confirmDeleteScenario(params.id);
                        break;
                }
            });

            $(tree.value).on("select_node.jstree", (e, data) => {
                selectedTreenode.value = data.node;
            });

            let searchTimeout = null;

            document.getElementById("searchComponent").addEventListener("keyup", function () {
                let searchText = this.value.trim().toLowerCase();
                let treeInstance = $('#jstree-scenarios').jstree(true);

                clearTimeout(searchTimeout);
                searchTimeout = setTimeout(function () {
                    treeInstance.search(searchText);
                }, 250);

                $("#jstree-scenarios").find(".highlighted").removeClass("highlighted");

                if (searchText.length > 0) {
                    setTimeout(function () {
                        let nodes = $("#jstree-scenarios").find(".jstree-search");

                        nodes.each(function () {
                            let node = $(this);

                            if (node.text().toLowerCase().includes(searchText)) {
                                node.addClass("highlighted");
                            }

                            let parents = node.parents(".jstree-node");
                            treeInstance.open_node(parents);
                        });
                    }, 300);
                }
            });
        });

        return {
            tree,
            hubs,
            facilityId,
            toggleScenario,
            confirmDeleteModal,
            deleteScenario,
        };
    },
};
</script>

<style scoped>
.component-action {
  min-width: 220px !important;
}
</style>
